import { createSlice } from '@reduxjs/toolkit/dist'

const initialState = {
  data: [],
  isLoading: false,
  isSuccess: false,
}

export const allGameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setGame: (state, action) => {
      state.data = action.payload
      state.isSuccess = true
    },
  },
  // extraReducers: {
  // 	[getGames.pending]: state => {
  // 		state.isLoading = true
  // 	},
  // 	[getGames.fulfilled]: (state, { payload }) => {
  // 		state.isLoading = false
  // 		state.data = payload
  // 		state.isSuccess = true
  // 	},
  // 	[getGames.rejected]: state => {
  // 		state.isLoading = false
  // 		state.isSuccess = false
  // 	},
  // },
})

export const { setGame } = allGameSlice.actions

export default allGameSlice.reducer
